import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { LoadingController, ModalController, AlertController, ToastController } from '@ionic/angular';
import { AuthService } from '../../services/user/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, style, animate, transition } from '@angular/animations';
import { ConfirmacaoPage } from '../confirmacao/confirmacao.page'
import jwt_decode from "jwt-decode";
import { PassaObjetoService } from '../../services/passa-objeto.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(900, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class LoginPage implements OnInit {

  public loginForm: FormGroup;
  public emailForm: FormGroup;
  public loading: HTMLIonLoadingElement;
  loginInstitucional = true
  usuario: any
  isEmail = false

  constructor(
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public modalController: ModalController,
    private passaObjetoService: PassaObjetoService,
    public toastCtrl: ToastController,
    private formBuilder: FormBuilder
  ) {
    this.loginForm = this.formBuilder.group({
      login: ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(3)])]
    });
    this.emailForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])]
    });


  }

  ngOnInit() {
    let tipoLogin
    this.activatedRoute.paramMap.subscribe(params => {
      tipoLogin = params.get('login');
      // console.log(tipoLogin);// OUTPUT 1534
      if (tipoLogin === 'institucional') {
        this.loginInstitucional = true
      } else {
        this.loginInstitucional = false
      }

      if (tipoLogin === 'confirmacao') {
        this.modalConfirmacao(this.passaObjetoService.navParams.userObj)
      }

    });

  }

  mudaLogin() {
    this.loginInstitucional == true ? this.loginInstitucional = false : this.loginInstitucional = true
    // console.log(this.loginInstitucional)
  }


  async chamaAlerta(message, buttons) {
    const alert = await this.alertCtrl.create({
      message,
      buttons
    });
    await alert.present();
  }

  async modalConfirmacao(usuario) {
    const modal = await this.modalController.create({
      component: ConfirmacaoPage,
      componentProps: { usuario },
      backdropDismiss: true,
      animated: false,
      mode: 'ios'

    });
    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (!data || data.length == 0 || data == 'fechar') {
      // console.log("nada!")
    } else {
      if (data.acao === 'confirmado') {
        this.emailUserLogin(null, usuario);
      }
    }
  }

  noEmail(event) {
    this.loginForm.value.login.includes("@") ? this.isEmail = true : this.isEmail = false
  }

  logout() {
    this.authService.logoutUsuario().subscribe(data => {
      let message
      if (data['success'] == true) {
        localStorage.removeItem('cvusr');
        this.setCookie('usrmat', null, 0)
        message = "Sucesso"
        this.presentToast(message, 'success', 2000)
        window.location.reload()
      } else {


      }
    })
  }

  async presentToast(message, color, duration) {
    const toast = await this.toastCtrl.create({
      message,
      mode: 'ios',
      position: 'middle',
      color,
      duration,
    });
    toast.present();
  }

  async loginSCA(loginForm: FormGroup, usee) {
    this.loading = await this.loadingCtrl.create();
    await this.loading.present();
    // console.log('emailForm', loginForm.value.login)
    let userObj = {}

    userObj['username'] = loginForm.value.login;
    userObj['password'] = loginForm.value.password;

    function getLogin(str) {
      return str.split('@')[0];
    }

    userObj['username'] = getLogin(userObj['username'])

    this.authService.getToken(userObj).subscribe((response: any) => {
      console.log('response', response)
      if (response.body.success === true) {
        this.authService.getAuth(response.body.data.token).subscribe((response: any) => {
          this.loading.dismiss().then(() => {
            this.authService.usuarioLogado = jwt_decode(response.data.token)
            this.setCookie('usrmat', this.authService.usuarioLogado.matricula, 10)
            window.location.reload()
          });
        })
      } else { //erro
        let buttons = [{ text: 'Ok', role: 'cancel' }]

        this.loading.dismiss().then(() => {
          this.chamaAlerta(response.body.error.message, buttons)
        });


      }


    })
    let _self = this
    setTimeout(function () {
      _self.loading.dismiss()
    }, 10000);
  }

  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  async emailUserLogin(emailForm: FormGroup, usuario) {
    this.loading = await this.loadingCtrl.create();

    let userObj
    if (emailForm !== null) {
      userObj = this.emailForm.value;
    } else {
      userObj = usuario;
    }

    function getSecondPart(str) {
      return str.split('@')[1];
    }
    function getFirstPart(str) {
      return str.split('.')[0];
    }
    function getLogin(str) {
      return str.split('@')[0];
    }

    let eTerc = userObj.email.endsWith(".terc@mprj.mp.br");

    let dominio = getSecondPart(userObj.email)
    let dominioFirst = getFirstPart(dominio)
    let login = getLogin(userObj.email)

    console.log(eTerc, userObj.email)

    if (
      (dominio === "mprj.mp.br" ||
        dominio === "mprj.mo.br" ||
        dominio === "morj.mp.br" ||
        dominioFirst === "mprj") && eTerc === false
    ) {
      // console.log('nao pode')
      this.loading.dismiss().then(() => {
        this.loginForm.controls['login'].setValue(login);
        let buttons = [{ text: 'Ok', role: 'cancel' }]
        this.chamaAlerta("Login institucional.  Utilize apenas o seu login (sem o '@mprj.mp.br')", buttons)
        this.mudaLogin()
        return
        // this.router.navigateByUrl('/login');
      });
      return
    }



    // userObj['username'] = this.emailForm.value.email;  // comentar depois ###########################
    // console.log("userObj", userObj)
    await this.loading.present();
    this.authService.loginUsuario(userObj).subscribe(

      res => {
        console.log('HTTP response', res)
        if (res['cod'] == 200) {
          this.setCookie('usrmat', "database", 10)
          //   localStorage.setItem("cvusr", JSON.stringify("database"));
          this.loading.dismiss().then(() => {
            // this.authService.getUserData('')
            window.location.reload()
            // this.router.navigateByUrl('/novo-saude');
          });
        }

      },
      err => {
        this.loading.dismiss()
        console.log('HTTP Error', err)
        if (err.error.cod == 401) {
          let message
          if (err.error.status === "ERRO AO EFETUAR LOGIN: SENHA INVALIDA") {
            message = "Não foi possível realizar o login.  Por favor, verifique a senha utilizada."
            this.emailForm.controls['email'].setValue(userObj.email);
          } else {
            message = "Usuário não cadastrado.  Por favor, verifique os dados ou faça seu cadastro."
          }
          this.loading.dismiss().then(() => {

            let buttons = [{ text: 'Ok', role: 'cancel' }]
            this.chamaAlerta(message, buttons)
            return
            // this.router.navigateByUrl('/login');
          });
        }
        if (err.error.cod == 403) {
          this.loading.dismiss().then(() => {
            let message = "É necessária a confirmação do e-mail cadastrado. Verifique seu e-mail e tente realizar o login novamente."
            let buttons = [{ text: 'Ok', handler: (d) => this.modalConfirmacao(userObj) }]
            this.chamaAlerta(message, buttons)

            this.router.navigateByUrl('/login');
          });
        } else {
          this.loading.dismiss()
        }
      },
      () => this.loading.dismiss()
    );


  }




}



